import { observable, action } from 'mobx';

import DocumentListItem from '../Models/DocumentListItem';
import * as CONNECTION from '../Constants/Connection';
import DocumentService from '../Services/DocumentService';

class DocumentStore {
  @observable public docList: Array<DocumentListItem>;
  @observable public isDocListLoaded: boolean;
  @observable public isDocListAllLoaded: boolean;
  @observable public isDocListLoadError: boolean;
  @observable public activeDamPath: string = CONNECTION.GENERALINFORMATIONDOCUMENTSPATH;

  private _docService: DocumentService = new DocumentService();
  private _docListPage = 1;

  constructor() {
    this.isDocListAllLoaded = false;
  }

  @action
  setActiveDamPath = (damPath: string) => {
    this.activeDamPath = damPath;
  }

  @action
  resetDocumentList = () => {
    this.docList = undefined as any;
    this._docListPage = 1;
    this.isDocListAllLoaded = false;
    this.isDocListLoaded = false;
    this.isDocListLoadError = false;
  }

  @action
  getDocumentList = async () => {
    this.isDocListLoadError = false;

    try {
      const response = await this._docService.getDocumentsList(this.activeDamPath, this._docListPage);
      const newPage = this._docListPage + 1;

      if (response!.data.searchResults.length === 0) {
        this.isDocListAllLoaded = true;
      }

      if (!this.docList) {
        this.docList = response!.data.searchResults;
        this._docListPage = newPage;
      } else {
        this.docList.push(...response!.data.searchResults);
        this._docListPage = newPage;
      }
      this.isDocListLoaded = true;
    } catch (error) {
      this.isDocListLoadError = true;
      this.isDocListLoaded = true;
    }
  }

  getNZFAPDocumentList = async () => {
    return this.getDocumentList();
  }

  getDocument = async (docId: string) => {
    return this._docService.getSingleDocument(docId);
  }

  getNZFAPDocument = async (docId: string) => {
    return this.getDocument(docId);
  }
}

export default DocumentStore;
